import { ESectionColor, Section } from '@web_opxp/components';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import './Checkout.scss';
import Cancel from './views/Cancel';
import Progress from './views/Progress';
import Success from './views/Success';

export default function Checkout() {
  return (
    <Section className="checkout-session" color={ESectionColor.blue}>
      <Switch>
        <Route exact path="/checkout/success">
          <Success />
        </Route>
        <Route exact path="/checkout/cancel">
          <Cancel />
        </Route>
        <Route path="/checkout/:planId">
          <Progress />
        </Route>
      </Switch>
    </Section>
  );
}
